import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TrendingUp, BarChart3, DollarSign, Users } from 'lucide-react';
import './AnalyticsTab.css';

const AnalyticsTab = ({ hotelId, token }) => {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (hotelId && token) {
      fetchDashboard();
    }
  }, [hotelId, token]);

  const fetchDashboard = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/analytics/rooms/dashboard`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDashboard(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching dashboard:', err);
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="tab-loading"><div className="loading-spinner"></div><p>Loading analytics...</p></div>;
  }

  if (!dashboard) {
    return <div className="empty-state"><TrendingUp size={48} /><h3>No Analytics Data</h3><p>Data will appear once bookings are made</p></div>;
  }

  const { rooms, occupancy, revenue, maintenance, housekeeping } = dashboard;

  return (
    <div className="analytics-tab">
      <div className="tab-header">
        <h2><TrendingUp size={24} /> Analytics Dashboard</h2>
      </div>

      <div className="analytics-grid">
        <div className="analytics-card">
          <div className="card-icon"><BarChart3 size={32} /></div>
          <div className="card-content">
            <h3>{rooms?.occupancy_rate || occupancy?.occupancy_rate || 0}%</h3>
            <p>Occupancy Rate</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon"><DollarSign size={32} /></div>
          <div className="card-content">
            <h3>${revenue?.total_revenue?.toLocaleString() || 0}</h3>
            <p>Total Revenue (30d)</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon"><Users size={32} /></div>
          <div className="card-content">
            <h3>{revenue?.total_bookings || 0}</h3>
            <p>Total Bookings</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon"><TrendingUp size={32} /></div>
          <div className="card-content">
            <h3>{rooms?.available_rooms || 0}</h3>
            <p>Available Rooms</p>
          </div>
        </div>
      </div>

      <div className="analytics-details">
        <div className="detail-card">
          <h3>Room Status</h3>
          <div className="status-breakdown">
            <div className="status-item"><span className="dot available"></span> Available: {rooms?.available_rooms || 0}</div>
            <div className="status-item"><span className="dot occupied"></span> Occupied: {rooms?.occupied_rooms || 0}</div>
            <div className="status-item"><span className="dot maintenance"></span> Maintenance: {rooms?.maintenance_rooms || 0}</div>
            <div className="status-item"><span className="dot cleaning"></span> Cleaning: {rooms?.cleaning_rooms || 0}</div>
          </div>
        </div>

        <div className="detail-card">
          <h3>Housekeeping</h3>
          <p>Total Tasks: {housekeeping?.total_tasks || 0}</p>
          <p>Completed: {housekeeping?.completed_tasks || 0}</p>
          <p>Pending: {housekeeping?.pending_tasks || 0}</p>
        </div>

        <div className="detail-card">
          <h3>Maintenance</h3>
          <p>Total Issues: {maintenance?.total_issues || 0}</p>
          <p>Pending: {maintenance?.pending_issues || 0}</p>
          {maintenance?.total_maintenance_cost && <p>Total Cost: ${maintenance.total_maintenance_cost}</p>}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsTab;
